import styled from 'styled-components'
import { Card } from 'react-bootstrap'
import CardBodyContainer from '../../../common/styles/CardBodyContainer'
import CardTitle from '../../../common/styles/CardTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import useLoginStore from '../../login/useLoginStore'
import BookStatisticsTable from '../../book/statitics/BookStatisticsTable'
import IndexContentContainer from '../IndexContentContainer'
import BookGoalCard from '../../book/goal/BookGoalCard'
import BookLastReadCard from '../../book/BookLastReadCard'
import Login from '../../../common/Login'
import ContentContainer from '../../../common/styles/ContentContainer'
import useBookGoal from '../../book/goal/useBookGoal'
import { useEffect, useState } from 'react'
import useBookGoalStore from '../../book/goal/useBookGoalStore'
import BookStreakCard from '../../book/streak/BookStreakCard'
import useBookStreak from '../../book/streak/useBookStreak'
import { Form } from 'react-bootstrap'
import IndexTimeOfDayCard from './IndexTimeOfDayCard'
import IndexDayOfWeekCard from './IndexDayOfWeekCard'

const IndexSummaryCard = () => {
	const isLoggedIn = useLoginStore(state => state.isLoggedIn())

	return (
		<Card>
			<CardBodyContainer height={400}>
				<CardTitle icon={<booksitoutIcon.user />} title={'내 독서활동 요약'} url="/book/mine?range=READING" />

				{isLoggedIn ? <YesLoggedInCase /> : <NoLoggedInCase />}
			</CardBodyContainer>
		</Card>
	)
}

const NoLoggedInCase = () => {
	return <Login message={null} />
}

const YesLoggedInCase = () => {
	const { init } = useBookGoalStore()
	const [goal, isGoalDone, isGoaloading] = useBookGoal(new Date().getFullYear())
	useEffect(() => {
		init(goal ? [goal] : [])
	}, [goal])

	const [streakCount, isTodayDone, isStreakLoading] = useBookStreak()

	const currentYear = new Date().getFullYear()
	const [selectedYear, setSelectedYear] = useState(currentYear)

	return (
		<Row>
			<Col>
				<LeftRow>
					<IndexContentContainer height={200} backgroundColorType={'card-card'} marginBottom={0}>
						<BookLastReadCard />
					</IndexContentContainer>

					<ContentContainer href="/book/goal" backgroundColor={'card-card'}>
						<BookGoalCard isLoading={isGoaloading} />
					</ContentContainer>

					<ContentContainer href="/book/statistics" backgroundColor={'card-card'}>
						<BookStreakCard streakCount={streakCount} isTodayDone={isTodayDone} isLoading={isStreakLoading} />
					</ContentContainer>
				</LeftRow>
			</Col>

			<Col>
				<StatisticsContainer href="/book/statistics">
					<StatisticsHeader>
						<StatisticsTitle>독서 요약</StatisticsTitle>
						<SelectorContainer onClick={e => e.preventDefault()}>
							<Form.Select size="sm" value={selectedYear} onChange={e => setSelectedYear(Number(e.target.value))}>
								{Array.from({length: 10}, (_, i) => (
									<option key={currentYear - i} value={currentYear - i}>
										{currentYear - i}년
									</option>
								))}
							</Form.Select>
						</SelectorContainer>
					</StatisticsHeader>
					<BookStatisticsTable year={selectedYear} backgroundColorType={'card-card'}/>
				</StatisticsContainer>
			</Col>

			<Col>
				<IndexTimeOfDayCard />
			</Col>

			<ColSmallOnly>
				<IndexDayOfWeekCard />
			</ColSmallOnly>
		</Row>
	)
}

const Row = styled.div.attrs({
	className: 'row',
})``

const Col = styled.div.attrs({
	className: 'col-12 col-md-6 col-xl-4',
})`
	margin-bottom: 20px;
`

const StatisticsContainer = styled.a`
	display: block;
	text-decoration: none;
	color: inherit;
	background-color: var(--card-card-bg-color);
	border-radius: 16px;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
	padding: 20px;
	height: 100%;

	&:hover {
		color: inherit;
	}
`

const StatisticsHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
`

const StatisticsTitle = styled.h5`
	margin: 0;
	color: var(--text-color);
	font-weight: bold;
`

const SelectorContainer = styled.div`
	width: 100px;
	flex-shrink: 0;
`

const ColSmallOnly = styled.div.attrs({
	className: 'col-12 col-md-6 d-xl-none',
})`
	margin-bottom: 20px;
`

const LeftRow = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: 100%;
`


export default IndexSummaryCard
